import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export var numberOnly = function numberOnly(value) {
  return value.replace(/[^0-9.,]/g, '').replace(/,/g, '.').replace(/^\.$/g, '').replace(/(\..*?)\..*/g, '$1');
};
//# sourceMappingURL=numberOnly.js.map